import styled from 'styled-components';
import hexToRGBA from 'utils/hexToRGBA';
import { colors, fontWeight } from 'utils/variables';

export const stateMapper = {
  error: {
    labelColor: colors.error,
    inputBorder: colors.error,
    inputBorderColorFocus: colors.error,
  },
  success: {
    labelColor: colors.success,
    inputBorder: colors.success,
    inputBorderColorFocus: colors.success,
  },
};

export const StyledText = styled.div`
  display: inline-flex;
`;

export const StyledLabel = styled.label`
  z-index: 10;
  display: inline-flex;
  position: absolute;
  align-items: center;
  font-weight: ${fontWeight.light};
  font-size: 1.4rem;
  margin-left: 3rem;
  cursor: text;
  color: ${({ theme }) => theme.labelColor || colors.grayCobalt};
  height: 6rem;
  transition: margin 300ms ease, opacity 300ms ease-out;
  margin-top: ${({ filled }) => filled && '-5.1rem'};
  opacity: ${({ filled }) => (filled ? '1' : '0')};
`;

export const StyledInput = styled.input`
  z-index: 20;
  height: 6.4rem;
  width: 100%;
  padding: 0 1.5rem;
  background-color: ${colors.white};
  border: ${({ theme }) => (theme.inputBorder ? `0.2rem solid  ${theme.inputBorder}` : `0.2rem solid ${colors.butter}`)};
  border-radius: 0.3rem;
  outline: 0;
  caret-color: ${hexToRGBA(colors.grayCobalt, 0.7)};
  color: ${hexToRGBA(colors.grayCobalt, 0.8)};
  font-weight: ${fontWeight.light};
  font-size: 1.4rem;
  transition: border 300ms ease;

  &::placeholder {
    color: ${hexToRGBA(colors.grayCobalt, 0.8)};
    font-weight: ${fontWeight.light};
    font-size: 1.5rem;
    transition: opacity 500ms ease;
    letter-spacing: -0.05rem;
  }

  &:focus::placeholder {
    opacity: 0;
    transition: opacity 50ms ease;
  }

  &:focus ~ label {
    margin-top: -5.1rem;
    opacity: 1;
  }

  &:focus {
    border-color: ${({ theme }) => theme.inputBorderColorFocus || colors.butter};
  }
`;

export const StyledMsgBox = styled.span`
  z-index: 10;
  display: inline-flex;
  position: absolute;
  align-items: center;
  font-weight: ${fontWeight.light};
  font-size: 1.2rem;
  cursor: text;
  color: ${colors.error};
  transition: margin-top 300ms ease, opacity 300ms ease-out;
  margin: ${({ children }) => (children ? '7.5rem 0 0 3rem' : '0 0 0 3rem')};
  opacity: ${({ children }) => (children ? '1' : '0')};
`;
